"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
require("Hubspot/Hubspot.ng.html");
var TokensController_1 = require("./Tokens/TokensController");
var NewProjectController_1 = require("./NewProject/NewProjectController");
var PreviewController_1 = require("./Preview/PreviewController");
var ProjectStore_1 = __importDefault(require("Project/Stores/ProjectStore"));
module.exports = angular.module("qwilr.hubspot", ["ui.router"]).config(function ($stateProvider) {
    return $stateProvider.state("hubspotProject", {
        url: "/hubspot/:action/:id?",
        templateUrl: "Hubspot/Hubspot.ng.html",
        controller: function ($scope, $stateParams, $rootScope) {
            var _this = this;
            var di = $rootScope.di.child();
            return di.invoke(function ($log) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    switch ($stateParams.action) {
                        case "new":
                            di.invoke(showNewProjectScreen, null, {
                                $scope: $scope,
                            });
                            break;
                        case "pdf":
                            di.invoke(showPdfScreen, null, {
                                $stateParams: $stateParams,
                            });
                            break;
                        case "tokens":
                            di.invoke(showTokenScreen, null, {
                                $scope: $scope,
                            });
                            break;
                        case "preview":
                            di.invoke(showPreviewScreen, null, {
                                $scope: $scope,
                                $stateParams: $stateParams,
                            });
                            break;
                        default:
                            return [2, $log.error("Invalid hubspot action ".concat($stateParams.action))];
                    }
                    return [2];
                });
            }); });
        },
    });
});
var showNewProjectScreen = function ($scope, $state, $location, mountReactComponent, apiBaseUrl) {
    var goToProjectState = function (projectId) {
        $state.go("hubspotProject", {
            section: "project",
            id: projectId,
            action: "preview",
        });
    };
    $scope.ui = (0, NewProjectController_1.mountNewProject)(mountReactComponent, apiBaseUrl, goToProjectState, $location.search());
};
var showPdfScreen = function ($http, $stateParams, make, apiBaseUrl, PdfExport) { return __awaiter(void 0, void 0, Promise, function () {
    var project;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, fetchProject($http, apiBaseUrl, $stateParams.id)];
            case 1:
                project = _a.sent();
                make(PdfExport, {
                    project: project,
                    overlayOptions: { hideCloseButton: true, keepOverlay: true },
                });
                return [2];
        }
    });
}); };
var showTokenScreen = function ($location, $scope, mountReactComponent, apiBaseUrl) {
    var _a = $location.search(), objectType = _a.objectType, objectId = _a.objectId;
    $scope.ui = (0, TokensController_1.mountTokens)(mountReactComponent, apiBaseUrl, objectType, objectId);
};
var showPreviewScreen = function ($http, $stateParams, $location, $scope, $timeout, apiBaseUrl, mountReactComponent, notifyUser, projectService, user, genericHost, clientUrl, di) { return __awaiter(void 0, void 0, Promise, function () {
    var project, projectStore, previewAction;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, fetchProject($http, apiBaseUrl, $stateParams.id)];
            case 1:
                project = _a.sent();
                projectStore = di.make(ProjectStore_1.default, {
                    projectData: project,
                    _user: user,
                    angularSyncServices: { disableSync: true },
                });
                previewAction = $location.search().action;
                delete $location.search().action;
                $timeout(function () {
                    $scope.ui = (0, PreviewController_1.mountPreview)(mountReactComponent, notifyUser, projectService, projectStore, user, genericHost, $location.protocol(), clientUrl, previewAction);
                });
                return [2];
        }
    });
}); };
var fetchProject = function ($http, apiBaseUrl, id) { return __awaiter(void 0, void 0, Promise, function () {
    var projectResponse;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4, $http.get("".concat(apiBaseUrl, "/projects/").concat(id))];
            case 1:
                projectResponse = _a.sent();
                return [2, projectResponse.data];
        }
    });
}); };
